import { useState } from "react";
import { createContainer } from "unstated-next";
import { StampService } from "../services/StampService";
import { Recommend } from "./StampCard"

type Stamps = {
  category?: string;
  stampList: Stamp[];
};

export type Stamp = {
  id: string;
  image: string;
  name: string;
  area: string[];
  areaNumber: number[];
  isBanditTarget?: boolean;
  banner?: string,
  genre?: string,
  budget?: string,
  businessHours?: string,
  tel?: string,
  description?: string,
  others?: string
}

/**
 * スタンプ一覧コンテナ
 */
const useStampsContainer = () => {
  const [stamps, setStamps] = useState<Stamps>({ stampList: [] });

  /**
   * 対象カテゴリのスタンプ一覧を取得する
   * @param campaignId キャンペーンID
   * @param category カテゴリ
   * @param recommends リコメンド
   */
  const getStampList = async (campaignId: string, category: string, recommends: Recommend[]) => {
    // 対象カテゴリのスタンプ一覧を取得
    const stampDataList = await StampService().getStampList(campaignId, category);
    const stamps = stampDataList.map((stampData) => {
      return {
        id: stampData.id,
        image: stampData.data.image,
        name: stampData.data.displayName,
        area: stampData.data.area,
        areaNumber: stampData.data.areaNumber,
        isBanditTarget: stampData.data.isBanditTarget,
        banner: stampData.data.banner,
        genre: stampData.data.genre,
        budget: stampData.data.budget,
        businessHours: stampData.data.businessHours,
        tel: stampData.data.tel,
        description: stampData.data.description,
        others: stampData.data.others,
        coupon: stampData.data.coupon
      };
    });

    const pickupList = stamps.filter((s) => s.isBanditTarget);
    const stampList = stamps.filter((s) => !s.isBanditTarget);

    // ピックアップ部分のみ並び替え処理
    const normal = -1;
    const reverse = 1;
    pickupList.sort((a, b) => {
      const aIdx = recommends.findIndex((r) => r.id === a.id);
      const bIdx = recommends.findIndex((r) => r.id === b.id);

      // recommends 対象スタンプが先頭に来るように並び替え
      if (aIdx === -1 && bIdx === -1) {
        return normal;
      } else if (aIdx === -1) {
        return reverse;
      } else if (bIdx === -1) {
        return normal;
      }
      // recommends の順番になるように並び替え
      return aIdx - bIdx;
    });

    setStamps({ category: category, stampList: pickupList.concat(stampList) });
  };

  /**
   * スタンプ一覧のリセット
   */
  const resetStamps = () => {
    setStamps({ stampList: [] });
  };

  return {
    stamps,
    getStampList,
    resetStamps
  };
};

export const StampsContainer = createContainer(useStampsContainer);